import React from 'react';
import { connect } from 'react-redux';

import {
  brandSelector,
  brandLogoSelector,
} from 'redux/ui/selectors';

import immutableToJS from 'utils/immutableToJS';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function WithConnectedData(props) {
    return (<WrappedComponent {...props} />);
  }

  function mapStateToProps(state) {
    return {
      brand: brandSelector(state),
      logoImageUrl: brandLogoSelector(state),
    };
  }

  return connect(mapStateToProps)(
    immutableToJS(WithConnectedData),
  );
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/Logo/Container.js